/*global VeloxViewController, VeloxWebView*/

var uuid = require("uuid") ;

var mainController = new VeloxViewController({
    directory : "views/main",
    name: "main",
    container: "main",
    route: "" //displayed by default (no route)
}) ;

var langs = [{name: "fr-FR", country: "fr"}, {name: "en-GB", country: "gb"}, {name: "es-ES", country: "es"}, {name: "de-DE", country: "de"}] ;

mainController.prepareDataOnEnter = function(data, callback){
    var urlSearch = window.location.search ;
    if(urlSearch && /^\?lang=/.test(urlSearch)){
        var langSearch = urlSearch.substring(urlSearch.indexOf("=")+1) ;
        if(langSearch && langs.some(function(l){ return l.name === langSearch ;})){
            if(VeloxWebView.i18n.getLang() !== langSearch){
                VeloxWebView.i18n.setLang(langSearch) ;
                localStorage.setItem("lang", langSearch) ;
            }
        }
    }
    var currentLang = VeloxWebView.i18n.getLang() ;
    langs.forEach(function(l){
        l.selected = (l.name.indexOf(currentLang.substring(0,2)) === 0) ;
    }) ;
    var listStr = localStorage.getItem("bayrol-spare-list") ;
    var list = listStr?JSON.parse(listStr):null ;
    return callback(null, {
        langs : langs,
        user: this.api.currentUser,
        list: list
    }) ;
} ;

mainController.onLang = function(ev){
    localStorage.setItem("lang", ev.data.data.name) ;
    var urlSearch = window.location.search ;
    if(urlSearch && /^\?lang=/.test(urlSearch)){
        window.location.href = window.location.href.replace(urlSearch, "") ;
        return;
    }
    VeloxWebView.i18n.setLang(ev.data.data.name) ;
    this.refresh() ;
} ;

mainController.onLogout = function(){
    this.view.longTask(function(done){
        this.api.logout(function(err){
            if(err){ return done(err);}
            this.navigate("/") ;
            window.location.reload() ;
            done() ;
        }.bind(this)) ;
    }.bind(this));
} ;

mainController.onChangePassword = function(){
    this.view.longTask(function(done){
        var viewChange = new VeloxWebView("views/main", "changePassword") ;
        viewChange.openInPopup({
            title: VeloxWebView.tr("main.changePassword")
        }, function(){
            done() ;
        }.bind(this))  ;
        viewChange.on("cancel",function(ev){
            viewChange.close() ;
        });
        viewChange.on("validate",function(ev){
            var data = viewChange.getData() ;
            this.api.changeUserPassword(data.passwordOld, data.passwordNew, function(err, success){
                if(err){ return done(err);}
                if(!success){
                    return done(VeloxWebView.tr("main.wrongPassword")) ;
                }
                viewChange.close() ;
                VeloxWebView.info(VeloxWebView.tr("main.changePasswordSuccess"), done) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


mainController.addPartToList = function(part){
    var listStr = localStorage.getItem("bayrol-spare-list") ;
    var list = listStr?JSON.parse(listStr):{ items: [], size: 0 } ;
    if(!list.items.some(function(item){ return item.p_ref === part.p_ref ;})){
        list.items.push(part) ;
    }
    list.size = list.items.length ;
    localStorage.setItem("bayrol-spare-list", JSON.stringify(list)) ;
    this.data.list = list ;
    this.view.render() ;
    mainController.onListItems() ;
} ;

mainController.onListItems = function(){
    var listStr = localStorage.getItem("bayrol-spare-list") ;
    var list = listStr?JSON.parse(listStr):{ items: [], size: 0 } ;
    var subject = VeloxWebView.tr("list.mailSubject") ;
    var body = VeloxWebView.tr("list.mailBody")+"\n\n"+list.items.map(function(item){
        return " - "+item.p_ref+" : "+item.p_name ;
    }).join("\n") ;
    list.subject = encodeURIComponent(subject) ;
    list.body = encodeURIComponent(body) ;
    var viewList = new VeloxWebView("views/list", "popupList", {bindObject: list}) ;
    viewList.openInPopup({
        size:"medium",
        title: VeloxWebView.tr("menu.list")
    })  ;

    viewList.on("removeItem",function(ev){
        var part = ev.data.data ;
        list.items.some(function(item, i){
            if(item.p_ref === part.p_ref){
                list.items.splice(i, 1) ;
                return true ;
            }
        }) ;
        list.size = list.items.length ;
        viewList.render() ;
        localStorage.setItem("bayrol-spare-list", JSON.stringify(list)) ;
        this.data.list = list ;
        this.view.render() ;
        if(list.items.length === 0){
            this.data.list = null;
            localStorage.removeItem("bayrol-spare-list") ;
            this.view.render() ;
            viewList.close() ;
        }
    }.bind(this)) ;

    viewList.on("close",function(){ viewList.closePopup(); }) ;
    viewList.on("validate",function(){
        this.view.longTask(function(done){
            viewList.checkForm(function(err, formOK){
                if(err){ return done(err) ;}
                if(!formOK){ return done() ;}
                var data = viewList.getData() ;
                viewList.close() ;

                data.message += "<br /><table>";
                data.message += "<tr><th>"+VeloxWebView.tr("fields.part.p_ref")+"</th><th>"+VeloxWebView.tr("fields.part.p_name")+"</th></tr>";
                list.items.forEach(function(item){
                    data.message += "<tr><td>"+item.p_ref+"</td><td>"+item.p_name+"</td></tr>";
                }) ;
                data.message += "</table>";

                var mail1 = {
                    uid: uuid.v4(),
                    from_addr: "contact@bayrolsolution.com",
                    to_addr: data.email,
                    subject: "BAYROL "+VeloxWebView.tr("menu.list"),
                    text: data.message,
                    html: data.message,
                    status: "tosend",
                    schedule_type: "now",
                    schedule_date: new Date(),
                };

                var mail2 = JSON.parse(JSON.stringify(mail1)) ;
                mail2.uid = uuid.v4(),
                mail2.to_addr = data.yourEmail ;

                this.api.api.transactionalChanges([
                    {table: "velox_mail", action:"insert", record: mail1},
                    {table: "velox_mail", action:"insert", record: mail2}
                ], function(err){
                    if(err){ return done(err) ;}
                    this.data.list = null;
                    localStorage.removeItem("bayrol-spare-list") ;
                    this.view.render() ;
                    done() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ; 
        
    }.bind(this)) ;
} ;

mainController.onXlsx = function(){
    this.view.longTask(function(done){
        this.api.api.multiread({
            part: {search : {}, joinFetch: [
                { 
                    otherTable: "velox_translation", type: "2many",
                    thisField: "p_ref", otherField: "uid", name: "translations", joinSearch: {table_name:"part", col: "p_name"}
                }
            ]},
            exploded: {search : {}, joinFetch: [
                { 
                    otherTable: "velox_binary", 
                    thisField: "e_id", otherField: "table_uid", name: "binary", joinSearch: {table_name:"exploded"}
                },
                {   otherTable: "part_exploded_position", name:"positions", type: "2many" }
            ]},
            device: {search: {}, orderBy: "d_ref", joinFetch:  [
                {otherTable: "link_part_device", type:"2many", name: "parts", orderBy: "p_ref"},
            ]}
        }, function(err, reads){
            if(err){ return done(err) ;}
            
            var partsByRef = {} ;
            reads.part.forEach(function(p){
                partsByRef[p.p_ref] = p ;
            });
            var explodedByRef = {} ;
            reads.exploded.forEach(function(e){
                explodedByRef[e.d_ref] = e ;
            });
    
            reads.device.forEach(function(device){
                device.exploded = explodedByRef[device.d_ref] ;
                
                if(device.exploded){
                    device.exploded.positions.forEach(function(pos){
                        if(partsByRef[pos.p_ref]){
                            partsByRef[pos.p_ref].pos_number = pos.pos_number ;
                        }
                    }) ;
                }

                device.parts.forEach(function(lp){
                    var p = partsByRef[lp.p_ref] ;
                    lp.p_name = p.p_name;
                    lp.p_name_en = p.p_name;
                    lp.p_name_fr = p.p_name;
                    lp.p_name_de = p.p_name;
                    lp.p_name_es = p.p_name;
                    lp.pos_number = p.pos_number;
                    p.translations.forEach(function(tr){
                        lp["p_name_"+tr.lang.substring(0,2)] = tr.value ;
                    }) ;
                }) ;

                
                
            });

            reads.device.forEach(function(device){
                if(device.exploded){
                    delete device.exploded.positions;
                }
            });
    

            this.api.xls.genDevices(VeloxWebView.tr("menu.spareCatalog")+".xlsx", JSON.stringify(reads.device), done) ;
        }.bind(this)) ;
    }.bind(this)) ;
    


    
};

mainController.onPdf = function(){
    this.view.longTask(function(done){
        var iframe = document.createElement("IFRAME") ;
        var checkLoaded = function(callback){
            if(iframe.contentWindow && iframe.contentWindow.statusPdf === "pdfrendered"){
                var loader = iframe.contentWindow.document.getElementById("loader") ;
                if(!loader){
                    return callback() ;
                }
            }
            setTimeout(function(){
                checkLoaded(callback) ;
            }, 100) ;
        } ;
        iframe.src = "/index.html#pdf" ;
        //iframe.style.display = "none" ;
        checkLoaded(function(){
            var html = "<html><head>"+iframe.contentWindow.document.head.innerHTML+"</head><body>"+iframe.contentWindow.document.body.innerHTML+"</body></html>" ;
            html = html.replace('<script type="text/javascript" src="app_bundle.js"></script>', '') ;
            var indexSrc = html.indexOf('src="') ;
            while(indexSrc !== -1){
                var slash = "/" ;
                if(html[indexSrc+5] === "/"){
                    slash = "" ;
                }
                html = html.substring(0, indexSrc+5)+window.location.origin+slash+html.substring(indexSrc+5) ;
                indexSrc = html.indexOf('src="', indexSrc+1) ;
            }
            html = html.replace(/href="/g, 'href="'+window.location.origin+'/') ;
            this.api.pdf.gen(VeloxWebView.tr("menu.spareCatalog")+".pdf", html, function(err){
                if(err){ return done(err) ;}
                document.body.removeChild(iframe) ;
                done() ;
            }) ;
        }.bind(this)) ;

        document.body.appendChild(iframe) ;
    }.bind(this)) ;
};


/* 
The main controller is special, it should never been hidden because it contains others views 
So we change the default stack/unstack behaviour to "do nothing"
*/
mainController.stack = function(){} ;
mainController.unstack = function(){} ;


module.exports = mainController ;